import React from "react";

const HlpCentralEffices = () => {
  return (
    <>
      <h1>Your Effices</h1>
      Effices you have joined will be listed here as long as you are a member,
      no need for another invite link.
    </>
  );
};

export default HlpCentralEffices;
